//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from 'vue-avatar'
import { removeJwt } from '~/utils/jwt';

export default {
  computed: {
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null
    },
    isOpen() {
      return this.$store.state.rightSidebarOpen
    },
    hasBiometrics() {
      let localAuthTypes = _.get(this.$store.state.mobile, 'localAuthTypes', []);
      return _.size(localAuthTypes)
    },
    biometricMethod() {
      let localAuthTypes = _.get(this.$store.state.mobile, 'localAuthTypes', []);
      return _.first(localAuthTypes)
    },
    loginMethod() {
      let method = this.$store.state.mobile.loginMode;
      if(method === 'auto')
        return 'auto';
      if(method === 'biometric')
        return 'biometric';
      return null;
    },
  },
  components: {
    Avatar
  },
  watch: {
    isOpen: function (newVal, oldVal) {
      this.syncAutologinMethod();
    }
  },
  data() {
    return {
      //isOpen: true,
      autologinEnabled: false,
      selectedTab: null,
      sports: []
    }
  },
  mounted() {
    this.syncAutologinMethod();
  },
  methods: {
    formatLoginMethod(loginMethod) {
      switch (loginMethod) {
        case 'NONE':
          return 'None';
        case 'TOUCH_ID':
          return 'Touch ID';
        case 'FACE_ID':
          return 'Face ID';
        case 'FINGERPRINT':
          return 'Fingerprint';
        case 'FACE_AUTHENTICATION':
          return 'Face Authentication';
        case 'IRIS_AUTHENTICATION':
          return 'Iris Authentication';
        default:
          return '';
      }
    },
    async goTo(section = null) {
      this.$store.commit('openRightSidebar', false)
      this.$router.push(this.localePath(section))
    },

    async syncAutologinMethod() {
      if(this.platform === 'web')
        return;
      window.sendToWebView('get_login_mode')
    },

    async toggleAutologin(mode = 'auto') {
      let login_mode = _.get(this.$store.state.mobile, 'loginMode')
      let preffered_mode = 'auto';
      if(this.hasBiometrics) {
        preffered_mode = 'biometric';
      }

      if (mode === 'auto') {
        if (login_mode == 'auto') {
          window.sendToWebView('set_login_mode', {mode: null})
        } else {
          window.sendToWebView('set_login_mode', {mode: mode})
        }
      }

      if (mode === 'biometric') {
        if (login_mode === 'biometric') {
          window.sendToWebView('set_login_mode', {mode: null})
        } else {
          window.sendToWebView('set_login_mode', {mode: preffered_mode})
        }
      }

      this.syncAutologinMethod();
    },

    async logout() {
      try {
            let result = await this.$auth().post('/api/common/logout', {
                session_id: this.sessionToken,
            })
            window.zE("messenger", "logoutUser");
            this.$cookies.remove('cross-token');
            if (this.$braze) {
              this.$braze.changeUser('anonymous');
            }

            console.log('result', result)
      } catch(e) {}
      
      this.$store.commit('auth/clearAuthentication')
      removeJwt(this.$nuxt)
      setTimeout(() => {
        //window.location.reload()
        //this.loadGlobalIframe('request_sport_token')
      }, 1000)
      this.$store.commit('openRightSidebar', false)
      this.$root.$emit('logged_out')
      await this.$router.push(this.localePath({path: '/'}))
    },
    open() {
      this.$store.commit('openRightSidebar', true)
    },
    close() {
      this.$store.commit('openRightSidebar', false)
    },
    goBack() {
      this.$router.back()
    }
  }
}
